"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ReadingProgressBar() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const pathname = usePathname();

  // Only show on blog overview pages
  const isBlogPage = pathname.startsWith("/blog/");

  useEffect(() => {
    if (!isBlogPage) return;

    const handleScroll = () => {
      const blogContent = document.querySelector("main");
      
      if (!blogContent) {
        setScrollProgress(0);
        return;
      }

      // Get the end position of the blog content
      const contentEndPosition = blogContent.offsetTop + blogContent.offsetHeight;
      const viewportHeight = document.documentElement.clientHeight;
      
      // Scrollable distance = content end - viewport height
      const scrollableHeight = contentEndPosition - viewportHeight;

      if (scrollableHeight === 0) {
        setScrollProgress(0);
        return;
      }

      const scrolled = window.scrollY;
      const progress = (scrolled / scrollableHeight) * 100;
      setScrollProgress(Math.min(progress, 100));
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isBlogPage]);

  if (!isBlogPage) return null;

  return (
    <div
      className="fixed top-0 left-0 h-1 bg-gradient-to-r from-[#3950D1] to-[#BA00BA] z-10000"
      style={{
        width: `${scrollProgress}%`,
        transition: "width 0.1s ease-out",
      }}
      role="progressbar"
      aria-label="Reading progress"
      aria-valuenow={Math.round(scrollProgress)}
      aria-valuemin="0"
      aria-valuemax="100"
    />
  );
}
